import React from 'react';
import { useSelector } from 'react-redux';

import { getGalleryFooter } from '@/redux/selectors/listing/galleryFooter';

import GalleryHeader, { IGalleryHeader } from './GalleryHeader';

const GalleryHeaderContainer: React.FC = () => {
  const { title }: Partial<IGalleryHeader> = useSelector(getGalleryFooter);

  return <GalleryHeader title={title} />;
};

export default GalleryHeaderContainer;
